<script lang="ts" setup>
const { enabled: pulseFeaturesEnabled } = useFlag('PULSE_FEATURES')
const { enabled: issuesEnabled } = useFlag('SLEUTH_ISSUES')
const { enabled: skillsEnabled } = useFlag('SLEUTH_SKILLS')
const { enabled: newNavigationEnabled } = useFlag('NEW_NAVIGATION')

const showSearch = computed(() =>
  pulseFeaturesEnabled.value || issuesEnabled.value || skillsEnabled.value)
</script>

<template>
  <nav class="z-10 flex min-h-0 max-w-full flex-1 flex-col bg-blue-50 py-2 text-nav dark:bg-gray-950">
    <NavigationHeader class="mb-4" />
    <div v-if="showSearch" class="mb-4 flex items-center gap-1 px-2">
      <NavigationSearch />
      <InboxPopup v-if="pulseFeaturesEnabled" />
    </div>

    <template v-if="newNavigationEnabled">
      <NavigationGoTo v-if="skillsEnabled" class="mb-4" />
      <NavigationCurrentLocation class="mb-4" />
    </template>
    <template v-else>
      <NavigationWorkspace />
      <NavigationRepositories />
    </template>

    <UDivider class="my-2" />

    <NavigationNew />
    <NavigationHelp />
  </nav>
</template>
